var map = {
	"./abb-color.svg": 1725,
	"./afb-color.svg": 1726,
	"./afb.svg": 1727,
	"./alb-color.svg": 1728,
	"./alb.svg": 1729,
	"./amb-color.svg": 1730,
	"./amb.svg": 1731,
	"./bbbaidja-color.svg": 1732,
	"./bbbaidjaxxx-color.svg": 1733,
	"./bdinidjaxxx-color.svg": 1734,
	"./bimb-color.svg": 1735,
	"./bimb.svg": 1736,
	"./bkr-color.svg": 1737,
	"./bkr.svg": 1738,
	"./bmriidja-color.svg": 1739,
	"./bniaidja-color.svg": 1740,
	"./bninidja-color.svg": 1741,
	"./bninidjaxxx-color.svg": 1742,
	"./bpay-color.svg": 1743,
	"./brinidja002-color.svg": 1744,
	"./bsmdidjaxxx-color.svg": 1745,
	"./bsn-color.svg": 1746,
	"./bsn.svg": 1747,
	"./btanidjaxxx-color.svg": 1748,
	"./cenaidja-color.svg": 1749,
	"./cenaidjaxxx-color.svg": 1750,
	"./cimb-color.svg": 1751,
	"./cimb.svg": 1752,
	"./citi-color.svg": 1753,
	"./citi.svg": 1754,
	"./default-bank-icon-color.png": 1755,
	"./default-bank-icon.png": 1756,
	"./gxbank-color.svg": 1757,
	"./hlb-color.svg": 1758,
	"./hlb.svg": 1759,
	"./hsbc-color.svg": 1760,
	"./hsbc.svg": 1761,
	"./ibbkidjaxxx-color.svg": 1762,
	"./kwh-color.svg": 1763,
	"./kwh.svg": 1764,
	"./mbb-color.svg": 1765,
	"./mbb.svg": 1766,
	"./nispidjaxxx-color.svg": 1767,
	"./ocbc-color.svg": 1768,
	"./ocbc.svg": 1769,
	"./pbb-color.svg": 1770,
	"./pbb.svg": 1771,
	"./pinbidja-color.svg": 1772,
	"./rhb-b.svg": 1773,
	"./rhb-color-b.svg": 1774,
	"./rhb-color.svg": 1775,
	"./rhb.svg": 1776,
	"./scb-color.svg": 1777,
	"./scb.svg": 1778,
	"./tng-color.svg": 1779,
	"./uob-color.svg": 1780,
	"./uob.svg": 1781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;